import { AEyebrowProps } from '../../atoms/AEyebrow/AEyebrow.types';
import { AHeaderProps } from '../../atoms/AHeader/AHeader.types';
import { AAccentLineProps } from '../../atoms/AAccentLine/AAccentLine.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';

export enum MTextBlockFullAlignment {
  Centered = 'Centered',
  Left = 'Left',
}

export interface MTextBlockFullProps extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: MTextBlockFullAlignment;
  aEyebrow?: AEyebrowProps;
  aHeader?: AHeaderProps;
  aAccentLine?: AAccentLineProps;
  aSubheader?: ASubheaderProps;
  aBody?: ABodyProps;
  className?: string;
}
